import React from 'react'
import { useSelector } from 'react-redux'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { useTranslate } from 'src/localization/Trns'
import { selectAppName } from 'src/redux/selectors/session.selectors'

interface ForVendorsAndContractorsTooltipProps {
  openLeft: boolean
  hideMdUp?: boolean
  hideSmDown?: boolean
}

const ForVendorsAndContractorsTooltip: React.FC<
  ForVendorsAndContractorsTooltipProps
> = (props): React.ReactElement => {
  const translate = useTranslate()

  const appName = useSelector(selectAppName)

  return (
    <Tooltip
      openLeft={props.openLeft}
      hideMdUp={props.hideMdUp}
      hideSmDown={props.hideSmDown}
    >
      <p>
        {translate(
          'These cards can be created for recipients outside of your org in ${appName}, and do not require a login to be viewed and used by the recipient.',
          {
            appName: appName,
          },
        )}
      </p>
    </Tooltip>
  )
}

export default ForVendorsAndContractorsTooltip
